module.exports = __webpack_public_path__ + "static/media/apple-alt.adbd2b71.svg";